import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../core/models/list-item';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'irar-site-form',
  template: `
    <h1>{{site.title}}</h1>
    <form (ngSubmit)="saveSite()" [formGroup]="form">
      <table width="100%" border="0" cellpadding="5" cellspacing="0">
        <tr>
          <td align="right" colspan="4">
            <strong>*required field</strong>
          </td>
        </tr>
        	<input type="hidden" formControlName="id" [ngModel]="id" />
        	<input type="hidden" formControlName="abbreviation" [ngModel]="abbreviation"/>
          <input type="hidden" formControlName="title" [ngModel]="title"/>
          <input type="hidden" formControlName="parentLid" [ngModel]="parentLid"/>
          <input type="hidden" formControlName="active" [ngModel]="active"/>
          <input type="hidden" formControlName="optionalField1" [ngModel]="optionalField1"/>
          <input type="hidden" formControlName="optionalField2" [ngModel]="optionalField2"/>
      	<tr>
      		<td align="right" valign="top"><b>DESCRIPTION<strong>*</strong></b></td>
          <td colspan="3">
            <textarea formControlName="description" [ngModel]="description" rows="24" cols="50">
            </textarea>
          </td>
      	</tr>
        <tr>
          <td colspan="4" align="center">
            <button>Submit</button>
          </td>
        </tr>
      </table>
    </form>
  `
})
export class SiteFormComponent {
  @Input() site: ListItem;
  @Output() save: EventEmitter<ListItem> = new EventEmitter();

  form: FormGroup;

  constructor(fb: FormBuilder) {
    this.form = fb.group({
      'id': [null],
      'abbreviation': [null],
      'title': [null],
      'description': [null],
      'parentLid': [null],
      'active': [null],
      'optionalField1': [null],
      'optionalField2': [null]
    });
  }

  saveSite() {
    const updatedSite = this.form.getRawValue() as ListItem;
    this.save.emit(updatedSite);
  }

  get id() {
    if (!this.site && !this.site.id) { return 0; }
    return this.site.id;
  }

  get abbreviation() {
    if (!this.site && !this.site.abbreviation) { return ''; }
    return this.site.abbreviation;
  }

  get title() {
    if (!this.site && !this.site.title) { return ''; }
    return this.site.title;
  }

  get description() {
    if (!this.site && !this.site.description) { return ''; }
    return this.site.description;
  }

  get parentLid() {
    if (!this.site && !this.site.parentLid) { return 0; }
    return this.site.parentLid;
  }

  get active() {
    if (!this.site) { return true; }
    return this.site.active;
  }

  get optionalField1() {
    if (!this.site && !this.site.optionalField1) { return ''; }
    return this.site.optionalField1;
  }

  get optionalField2() {
    if (!this.site && !this.site.optionalField2) { return ''; }
    return this.site.optionalField2;
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/site-form.ts